import { ShallowRef, Ref, InjectionKey } from "vue";
import DocumentDO = App.Data.Explorer.DocumentDO;

export type GraphSettings = {
	shouldShowConfigurationText: boolean;
	showOnlyOldSnapshotDate: boolean;
};

export const documentKey = Symbol() as InjectionKey<Ref<DocumentDO>>;
export const derivedDocumentKey = Symbol() as InjectionKey<
	ShallowRef<DocumentDO>
>;
export const graphSettingsKey = Symbol() as InjectionKey<Ref<GraphSettings>>;
